import styled from 'styled-components';
import { Text14Regular } from '../Text/Text.styles';
import { theme, Transition } from '../../../styles/constants';

export const SingleValueText = styled.span`
  color: ${theme.colors.textColor};
  font-size: 1.5rem;
`;

export const SingleValueTextLight = styled(SingleValueText)`
  opacity: 0.6;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled(Text14Regular)`
  margin-left: 0.2rem;
  text-transform: capitalize;
`;

export const selectStyles = {
  control: baseStyles => ({
    ...baseStyles,
    background: `#fff`,
    minHeight: '4.8rem',
    borderRadius: '16px',
    fontSize: '1.5rem',
    boxShadow: 'none',
    outline: 'none',
    borderColor: '#97c9f1',
    fontWeight: '400',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#97c9f1',
    },
  }),
  placeholder: defaultStyles => {
    return {
      ...defaultStyles,
      color: '#0b3a5f',
      fontSize: '1.5rem',
      fontWeight: '300',
    };
  },
  input: defaultStyles => {
    return {
      ...defaultStyles,
      color: theme.colors.textColor,
    };
  },

  menu: baseStyles => ({
    ...baseStyles,
    background: `#fff`,
    borderRadius: '16px',
    border: '1px solid',
    boxShadow: 'none',
    overflow: 'auto',
    borderColor: '#97c9f1',
  }),
  singleValue: baseStyles => ({
    ...baseStyles,
    color: theme.colors.textColor,
  }),
  option: baseStyles => ({
    ...baseStyles,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: '1rem',
    color: theme.colors.textColor,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#BADAF760',
      transition: Transition.hover.on,
    },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: baseStyles => ({
    ...baseStyles,
    color: '#1672BA',
    height: '3.4rem',
  }),
};

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  position: relative;
  width: fit-content;
  margin-bottom: 0.4rem;
`;
